export default __webpack_public_path__ + "static/media/messenger.c6a1ee37.svg";